(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("immutable"), require("te-flow"), require("defclass"), require("stylus"), require("fs"), require("path"), require("js-yaml"), require("colors"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "immutable", "te-flow", "defclass", "stylus", "fs", "path", "js-yaml", "colors"], factory);
	else if(typeof exports === 'object')
		exports["ctr"] = factory(require("lodash"), require("immutable"), require("te-flow"), require("defclass"), require("stylus"), require("fs"), require("path"), require("js-yaml"), require("colors"));
	else
		root["ctr"] = factory(root["lodash"], root["immutable"], root["te-flow"], root["defclass"], root["stylus"], root["fs"], root["path"], root["js-yaml"], root["colors"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_31__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition